import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var ActivitySuccessComponent = (function () {
    function ActivitySuccessComponent(apiService, route, router) {
        this.apiService = apiService;
        this.route = route;
        this.router = router;
    }
    ActivitySuccessComponent.prototype.ngOnInit = function () {
        this.specialUser = window.sessionStorage.getItem('specialUser');
        this.userType = window.sessionStorage.getItem('userType');
        var _this = this;
        var _submitType = Number(window.sessionStorage.getItem('submitType'));
        if (_submitType) {
            _this.submitType = _submitType;
        }
        else {
            _this.submitType = 1;
        }
    };
    ActivitySuccessComponent.prototype.ngAfterViewInit = function () {
        var html = document.documentElement;
        /*var htmlFontSize=html.clientWidth/7.5;*/
        var htmlFontSize;
        if (window.screen.width < window.screen.height) {
            htmlFontSize = window.screen.width / 7.5;
        }
        else {
            htmlFontSize = window.screen.height / 7.5;
        }
        html.style.fontSize = htmlFontSize + "px";
        html.style.backgroundColor = "rgb(246,247,252)";
    };
    ActivitySuccessComponent.prototype.close = function () {
        window.sessionStorage.removeItem('specialUser');
        var link = ['learning-map'];
        this.router.navigate(link);
    };
    return ActivitySuccessComponent;
}());
export { ActivitySuccessComponent };



// WEBPACK FOOTER //
// ./src/app/activity-success/activity-success.component.ts.pre-build-optimizer.js